import { Flex4XS, FlexCol2XS, FlexCol4XS, makeCentered } from '@/components/Flex';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';
import { Link } from '@/components/Link';
import { GreyTypography, NeedHelpBlock } from '@/app/[locale]/(welcome)/_components';
import { device } from '@/components/Media';

const Root = styled(FlexCol2XS)`
    width: 100%;
    align-items: center;
    text-align: center;

    @media ${device.laptopS} {
        gap: 6px;
    }
`;

const Wrapper = styled(FlexCol4XS)`
    @media ${device.laptopS} {
        gap: 6px;
    }
`;

const Divider = styled.div`
    width: 152px;
    height: 1px;
    content: ' ';
    background-color: ${({ theme }) => theme.colors.avatar.grey};
`;

const StyledLink = styled(Link)`
    @media ${device.laptopS} {
        display: block;
    }
`;

const StyledTypography = styled(GreyTypography)`
    @media screen and ${device.laptopS} {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
    }
`;

const CenteredFlex4XS = makeCentered(Flex4XS, {
    x: true
});

export function HelperText({ withPrivacyPolicy }: { withPrivacyPolicy?: boolean }) {
    const t = useTranslations();

    return (
        <Root>
            {withPrivacyPolicy && (
                <>
                    <Wrapper>
                        <Flex4XS>
                            <StyledTypography variant='uiType' size='sm' modifier='R'>
                                {t.rich('auth.bySigningUp', {
                                    termsLink: text =>
                                      <StyledLink
                                        href='https://help.moonone.online/account-and-security/terms-of-use'
                                        target='_blank'
                                        variant='uiType'
                                        size='sm'
                                        modifier='S'
                                      >
                                          {text}
                                      </StyledLink>
                                })}
                            </StyledTypography>
                        </Flex4XS>

                        <CenteredFlex4XS>
                            <StyledTypography variant='uiType' size='sm' modifier='R'>
                                {t.rich('auth.bySigningUpAnd', {
                                    privacyPolicyLink: text =>
                                      <StyledLink
                                        href={`${window.location.origin}/termsandpolicies/privacy_policy_moonone.pdf`}
                                        target='_blank'
                                        variant='uiType'
                                        size='sm'
                                        modifier='S'
                                      >
                                          {text}
                                      </StyledLink>
                                })}
                            </StyledTypography>&nbsp;
                        </CenteredFlex4XS>
                    </Wrapper>
                    <Divider />
                </>
            )}
            <NeedHelpBlock withDivider={!withPrivacyPolicy} />
        </Root>
    );
}
